var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parallelogram-wrapper"},[(_vm.vista && _vm.vista.config && _vm.vista.config.paso)?_c('div',{staticClass:"parallelogram",style:({ width: (_vm.vista.config.paso / _vm.config.cantPasos) * 100 + '%' })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }